import { useDevicesQuery } from '@data/device/device'
import { useAccountsQuery } from '@data/accounts/accounts'
import { useLocationsQuery } from '@data/locations/locations'
import { useActiveAlertsQuery } from '@data/alerts/alerts'

// Mount point for the shell's eager queries. Renders nothing and wraps nothing — it
// replaced three nested `*ContextProvider` wrappers that provided no context and only ever
// implied a dependency order that does not exist.
//
// It holds no selection effects any more, and the ordering notes that used to live here
// went with them. The location reconciler became part of the account-selection action
// (STATE-2), and the account bootstrap was deleted outright when the default selection
// stopped being written into the store and started being derived on read (STATE-1). What
// is left is a list of queries to warm, in no significant order.
const AppDataBootstrap = () => {
  useAccountsQuery()
  useLocationsQuery()
  useDevicesQuery()
  useActiveAlertsQuery()

  return null
}

export default AppDataBootstrap
